import { optionSearchTerms_automaticReplies } from './AutomaticRepliesOption.locstring.json';
import { optionSubcategory_automaticReplies } from 'owa-locstrings/lib/strings/optionsubcategory_automaticreplies.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { IsShadowMailboxUser } from 'owa-mail-ads-shared/lib/sharedAdsUtils';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
const AutomaticRepliesOption: LazyOption = createLazyOption(
    {
        key: 'automaticRepliesOption',
        titleStringKey: optionSubcategory_automaticReplies,
        hideTitleInFullOptions: true,
        searchTermsStringKey: optionSearchTerms_automaticReplies,
        isHidden: () => {
            return IsShadowMailboxUser();
        },
        allowedOptionKeys: ['AutomaticReplies'],
    },
    lazyFullModule,
    m => m.default
);
export default AutomaticRepliesOption;
